import { Component } from '@theme/component';

class HelloFloraReviewCarousel extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.abort = new AbortController();
    const options = { signal: this.abort.signal };
    this.addEventListener('click', this.handleClick, options);
    this.track?.addEventListener('scroll', this.update, { ...options, passive: true });
    this.observer = new ResizeObserver(this.update);
    if (this.track) this.observer.observe(this.track);
    this.querySelector('.hf-review-carousel__controls')?.removeAttribute('hidden');
    this.update();
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.abort?.abort();
    this.observer?.disconnect();
  }
  get track() { return this.querySelector('.hf-review-carousel__track'); }
  get cards() { return [...this.querySelectorAll('.hf-review-carousel__card')]; }
  get positions() {
    const cards = this.cards;
    if (!cards.length) return [];
    const start = cards[0].getBoundingClientRect().left;
    const max = this.track.scrollWidth - this.track.clientWidth;
    return [...new Set(cards.map(card => Math.round(Math.min(card.getBoundingClientRect().left - start, max))))];
  }
  get active() {
    let closest = 0;
    let distance = Infinity;
    this.positions.forEach((position, index) => {
      const next = Math.abs(position - Math.abs(this.track.scrollLeft));
      if (next < distance) { closest = index; distance = next; }
    });
    return closest;
  }
  update = () => {
    if (!this.track) return;
    const active = this.active;
    this.querySelectorAll('[data-index]').forEach((button, index) => {
      button.hidden = index >= this.positions.length;
      if (index === active) button.setAttribute('aria-current', 'true');
      else button.removeAttribute('aria-current');
    });
  };
  handleClick = (event) => {
    const button = event.target.closest('[data-index], [data-direction]');
    if (!button || !this.contains(button) || !this.track) return;
    const positions = this.positions;
    const index = button.hasAttribute('data-index') ? Number(button.dataset.index) : (this.active + Number(button.dataset.direction) + positions.length) % positions.length;
    const direction = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
    this.track.scrollTo({ left: positions[index] * direction, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  };
}
if (!customElements.get('hf-review-carousel')) customElements.define('hf-review-carousel', HelloFloraReviewCarousel);
